




















































































































import { Component, Vue } from 'vue-property-decorator';
import DateFormat from "date-fns/format";
import DateSub from "date-fns/subDays";
import {
    VehicleFilter,
    HistoricalVehicleLog,
    HistoricalDealershipLog,
    VehicleStateType,
    getVehicleStateLabel
} from "../../types";
import {
    createVehicleHistoryLog,
    getVehicleHistoryLogs,
    searchByArea,
    searchByAutoGroup,
    searchByDealership
} from "../../endpoints";
import {buildDealershipLink, buildVehicleLink} from "../../path";
import {serializeForm} from "../../util";
import Search from "../utility/Search.vue";
import {CloudFunctions} from "@/environment";

//Vue.component("v-search", Search);

@Component
export default class Revenue extends Vue {

    DateFormat = DateFormat;

    startDateModel = new Date();
    endDateModel = new Date();

    selectedUserId = null;

    invoiceRange = {};
    emptyInvoices = [];
    invoiceTotal = "";

    invoiceInspections = [];

    loadingDateRange = false;
    loadingInspections = false;

    mounted() {
        this.onDateChange();
    }

    async onDateChange() {

        this.loadingDateRange = true;

        const response = await window.fetch(`${CloudFunctions}/total_revenue_for_range`, {
            body: JSON.stringify({
                start: this.startDateModel.getTime(),
                end: this.endDateModel.getTime(),
                locations: [],
                technician: null
            }),
            method: "POST",
            credentials: 'same-origin',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
        });

        const json = await response.json();

        const invoicePerUser = {};

        let total = 0;

        json.invoices.forEach(function(invoice) {

            if(!invoicePerUser[invoice.user.id]) {
                invoicePerUser[invoice.user.id] = {
                    invoices: [],
                    user: invoice.user,
                    total_invoice_amount: 0,
                    inspection_count: 0
                };
            }

            invoicePerUser[invoice.user.id].invoices.push(invoice);
            invoicePerUser[invoice.user.id].inspection_count += invoice.inspections.length;

            total += invoice.total;
        });

        this.invoiceRange = invoicePerUser;

        if(json.no_invoices) {
            this.emptyInvoices = json.no_invoices.sort(function(a, b) {
                return a.localeCompare(b);
            });
        }

        this.invoiceTotal = total.toLocaleString();
        this.loadingDateRange = false;
    }

    async viewDetailedRevenue(userId: number) {

        this.selectedUserId = userId;

        (this.$refs['revenue-modal'] as any).show();

        this.loadingInspections = true;

        let response = await window.fetch(`${CloudFunctions}/retrieve_inspections`, {
            body: JSON.stringify({
                inspections: this.invoiceRange[userId].invoices.reduce((acc, val) => {
                    return acc.concat(val.inspections)
                }, [])
            }),
            method: "POST",
            credentials: 'same-origin',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
        });

        const inspections = await response.json();

        this.invoiceInspections = inspections.map(inspection => {
            const invoice = this.invoiceRange[userId].invoices.filter(invoice => {
                return invoice.inspections.indexOf(inspection.id) !== -1
            })[0];

            return {
                invoice,
                inspection
            }
        });

        this.loadingInspections = false;
    }

    get hasInvoicesForRange() {
        return Object.keys(this.invoiceRange).length > 0;
    }

}
